const hideLoadingForAllWhitepaper2024Forms = require("./hideLoadingForAllWhitepaper2024Forms");
const showSuccessForAllWhitepaper2024Forms = require("./showSuccessForAllWhitepaper2024Forms");

/**
 * @return {void}
 */
module.exports = function openSuccess() {
    hideLoadingForAllWhitepaper2024Forms();
    showSuccessForAllWhitepaper2024Forms();
}
